<template>
  <div class="relative">
    <div class="min-h-screen w-full">
      <DefaultHeader />
      <main :class="layoutWidth" class="mb-12">
        <RouterView />
      </main>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { LAYOUT_WIDTH } from '@/core/constants/layout.constant';
import DefaultHeader from '@/core/components/common/DefaultHeader.vue';

const layoutWidth = ref<string>();

const route = useRoute();
watch(
  route,
  (to) => {
    layoutWidth.value =
      (to.meta?.width ?? LAYOUT_WIDTH.DEFAULT) === LAYOUT_WIDTH.FULL
        ? 'w-full'
        : 'lg:container lg:mx-auto lg:max-w-(--breakpoint-xl)';
  },
  { flush: 'pre', immediate: true, deep: true },
);
</script>

<style lang="scss" scoped></style>
